import {
  CloseCircleOutlined,
  FilterOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Button, Flex, Form, Input, Select, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';

import { MultipleSelect } from '@app/components';
import { CustomAlert } from '@app/components/CustomAlert';
import { ERROR, maxLength, minLength, OFF } from '@app/constants';
import { TasksPeriodPicker } from '@app/pages/TasksList/components/TasksPeriodPicker';
import { FILTER_TYPES } from '@app/pages/TasksList/constants/filterTypes';
import { PERIOD_FILTER_DEFAULT_VALUE } from '@app/pages/TasksList/constants/registryFiltersDefaultKeys';
import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';

import '@app/pages/TasksList/styles/RegistryTableHeader.tablet.scss';
import '@app/pages/TasksList/styles/RegistryTableHeader.mobile.scss';

const { Text } = Typography;

const validationRules = {
  search: [minLength(), maxLength()],
};

export const TableHeader: React.FC<NTasksList.TableHeaderProps> = ({
  form,
  submitForm,
  handleReset,
  setSelectedStatuses,
  selectedStatuses,
  setSelectedEmployee,
  selectedEmployee,
  handleFilterClick,
  selectedCreators,
  setSelectedCreators,
  filtersData,
  periodTypeFilterList,
  statusesFilterList,
  ownersFilterList,
  creatorsFilterList,
  branchesFilterList,
  selectedBranches,
  setSelectedBranches,
  taskTypesFilterList,
  selectedTaskTypes,
  setSelectedTaskTypes,
}) => {
  const [searchError, setSearchError] = useState<string>('');

  useEffect(() => {
    if (filtersData && !form.getFieldValue('PeriodType')) {
      form.setFieldValue('PeriodType', PERIOD_FILTER_DEFAULT_VALUE);
    }
  }, [filtersData, form]);

  const handleSubmit = () => {
    submitForm(form.getFieldsValue());
  };

  const handlePeriodSave = (period: NTasksList.TableHeaderFormType['Date']) => {
    form.setFieldValue('Date', period);
    handleSubmit();
  };

  return (
    <div className="header-container">
      <Form
        form={form}
        autoComplete={OFF}
        onFinish={handleSubmit}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 30 }}
        layout="vertical"
        className="main-form"
      >
        <div className="toolbar-space">
          <div className="date-container">
            <div className="date-item">
              <Text className="label" strong>
                Период
              </Text>
              <Space className="period-time-wrapper">
                <Form.Item name="PeriodType">
                  <Select
                    className="period-type-selector"
                    options={periodTypeFilterList}
                  />
                </Form.Item>
                <Form.Item name="Date">
                  <TasksPeriodPicker onSave={handlePeriodSave} />
                </Form.Item>
              </Space>
            </div>
          </div>

          <Form.Item
            name="Search"
            wrapperCol={{ span: 16 }}
            rules={validationRules.search}
          >
            <Input
              placeholder="Поиск (по названию или описанию)"
              addonBefore={<SearchOutlined />}
            />
          </Form.Item>

          <div className="selectors-container">
            <Flex gap="16px" className="selectors" wrap={true}>
              <MultipleSelect
                defaultSelected={Boolean(selectedEmployee?.length)}
                className="user-selector"
                placeholder="Все ответственные"
                allOptions={ownersFilterList}
                width={225}
                selectedOption={selectedEmployee}
                setSelectedOptions={setSelectedEmployee}
                filterName="filterName"
              />

              <MultipleSelect
                defaultSelected={Boolean(selectedStatuses?.length)}
                className="user-selector"
                placeholder="Все статусы"
                allOptions={statusesFilterList}
                width={225}
                selectedOption={selectedStatuses}
                setSelectedOptions={setSelectedStatuses}
              />

              <MultipleSelect
                className="user-selector"
                placeholder="Все создатели"
                allOptions={creatorsFilterList}
                width={225}
                selectedOption={selectedCreators}
                setSelectedOptions={setSelectedCreators}
                filterName="filterName"
              />

              <MultipleSelect
                className="user-selector"
                placeholder="Филиалы клиентов"
                allOptions={branchesFilterList}
                width={225}
                selectedOption={selectedBranches}
                setSelectedOptions={setSelectedBranches}
                filterName="filterName"
              />

              <MultipleSelect
                className="user-selector"
                placeholder="Все типы задач"
                allOptions={taskTypesFilterList}
                width={225}
                selectedOption={selectedTaskTypes}
                setSelectedOptions={setSelectedTaskTypes}
                filterName="searchLabel"
              />
            </Flex>
          </div>

          <div className="filters-container">
            <div className="filter">
              {FILTER_TYPES.map((item, index) => (
                <Button
                  key={index}
                  type="link"
                  onClick={() => handleFilterClick(item.value)}
                >
                  {item.title}
                </Button>
              ))}
            </div>

            <div className="buttons-container">
              {searchError && (
                <CustomAlert
                  errorType={ERROR}
                  serverError={searchError}
                  setServerError={setSearchError}
                />
              )}
              <Space className="desktop-buttons" size="middle">
                <Button onClick={handleReset} className="button">
                  <CloseCircleOutlined />
                  Сброс
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="button"
                  onClick={handleSubmit}
                >
                  <FilterOutlined />
                  Поиск
                </Button>
              </Space>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};
